/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AdminFaq32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 7.692v16.616c0 2.675.278 3.645.801 4.622A5.452 5.452 0 003.07 31.2c.978.522 1.948.801 4.623.801h16.616c2.675 0 3.645-.279 4.622-.801A5.452 5.452 0 0031.2 28.93c.522-.977.801-1.947.801-4.622V7.692c0-2.675-.279-3.645-.801-4.623A5.452 5.452 0 0028.93.801C27.953.278 26.983 0 24.308 0H7.692C5.017 0 4.047.278 3.069.801A5.452 5.452 0 00.801 3.07C.278 4.047 0 5.017 0 7.692z"
            fill={vars.bdlGray80}
        />
        <path
            d="M11.583 20.146l-.5.217.259.479c1.169 2.167 3.441 3.642 6.058 3.642h1.496l4.39 1.909c.665.29 1.43-.027 1.71-.69h0c.069-.163.104-.338.104-.515v0-2.395a7.016 7.016 0 002.4-5.3c0-3.38-2.367-6.205-5.522-6.853l-.725-.15.133.729c.075.413.114.838.114 1.273 0 3.855-3.083 6.992-6.9 6.992h-1.496l-.095.042-1.426.62z"
            fill="#fff"
            stroke={vars.bdlGray80}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 12.492C21 8.907 18.135 6 14.6 6h-3.2C7.865 6 5 8.907 5 12.492c0 2.05.937 3.879 2.4 5.069v2.627c0 .11.022.219.065.32a.796.796 0 001.05.426L13 18.984h1.6c3.535 0 6.4-2.906 6.4-6.492zm-8.617-3.438A3.29 3.29 0 0112.996 9c.308 0 .585.039.832.118a1.8 1.8 0 01.631.336c.174.146.308.322.4.527.094.206.141.434.141.686 0 .238-.034.444-.103.619a1.693 1.693 0 01-.26.454c-.105.129-.22.24-.347.334-.126.094-.246.181-.36.26-.112.081-.21.16-.293.239a.528.528 0 00-.16.264l-.138.658h-1.042l-.108-.757a.63.63 0 01.05-.402c.058-.115.14-.219.243-.311.103-.093.218-.18.346-.264.128-.083.247-.172.36-.268a1.52 1.52 0 00.281-.32.75.75 0 00.116-.422.565.565 0 00-.194-.45c-.13-.11-.307-.166-.534-.166a1.532 1.532 0 00-.734.166c-.084.043-.156.08-.22.116a.377.377 0 01-.186.052.342.342 0 01-.314-.175L11 9.701c.121-.097.253-.188.395-.273a3.097 3.097 0 01.988-.374zm.043 5.399a.914.914 0 01.343-.063.901.901 0 01.615.235.756.756 0 01.25.57.776.776 0 01-.25.574.888.888 0 01-.615.231.945.945 0 01-.344-.06.838.838 0 01-.273-.171.786.786 0 01-.182-.89.805.805 0 01.182-.254.875.875 0 01.274-.172z"
            fill="#fff"
        />
    </AccessibleSVG>
);

export default AdminFaq32;
